var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAitTimesCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00002 13.3333C9.41451 13.3333 10.7711 12.7714 11.7713 11.7712C12.7715 10.771 13.3334 9.41448 13.3334 7.99999C13.3334 6.5855 12.7715 5.22895 11.7713 4.22875C10.7711 3.22856 9.41451 2.66666 8.00002 2.66666C6.58553 2.66666 5.22898 3.22856 4.22878 4.22875C3.22859 5.22895 2.66669 6.5855 2.66669 7.99999C2.66669 9.41448 3.22859 10.771 4.22878 11.7712C5.22898 12.7714 6.58553 13.3333 8.00002 13.3333ZM6.31252 6.31249C6.50835 6.11666 6.82502 6.11666 7.01877 6.31249L7.99794 7.29166L8.9771 6.31249C9.17294 6.11666 9.4896 6.11666 9.68335 6.31249C9.8771 6.50832 9.87919 6.82499 9.68335 7.01874L8.70419 7.99791L9.68335 8.97707C9.87919 9.17291 9.87919 9.48957 9.68335 9.68332C9.48752 9.87707 9.17085 9.87916 8.9771 9.68332L7.99794 8.70416L7.01877 9.68332C6.82294 9.87916 6.50627 9.87916 6.31252 9.68332C6.11877 9.48749 6.11669 9.17082 6.31252 8.97707L7.29169 7.99791L6.31252 7.01874C6.11669 6.82291 6.11669 6.50624 6.31252 6.31249Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAitTimesCircle);
export default __webpack_public_path__ + "static/media/aitTimesCircle.739f6ba9c1ea2726fbdd99c870ed5cb4.svg";
export { ForwardRef as ReactComponent };